module.exports = __webpack_public_path__ + "static/media/LcsBg.d5490176.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/LcsBg.png
// module id = 1708
// module chunks = 0 1